interface ErrorDescriptionProps {
  returnDescription: string;
}

interface UnitMeasure {
  unitMeasure?: string,
  unitMeasureCode?: string,
  unitMeasureType?: string,
  unitMeasureValue?: string,
}

interface Reason {
  reasonDescription?: string
  reasonStatus?: string
  sequenceNumber?: number
}

interface FormValuesProps {
  dateTime: string;
  infusionSpeed: string;
  justification: string;
  reason?: Reason
  unitMeasure: UnitMeasure,
}

enum SolutionType {
  ADULT_PARENTERAL_NUTRITION = 6,
  BLOOD_MANAGEMENT = 3,
  ENTERAL_NUTRITION = 2,
  NEONATAL_PARENTERAL_NUTRITION = 5,
  NEONATAL_PARENTERAL_PEDIATRIC = 7,
  SOLUTION = 1,
}

export {
  ErrorDescriptionProps, FormValuesProps, SolutionType, UnitMeasure
};

